import React from 'react';
import { Camera } from 'lucide-react';
import { brand } from '../mock';

export default function Navbar({ onSignIn, onSignUp }) {
  return (
    <header className="relative z-20 w-full">
      <div className="max-w-6xl mx-auto px-6 md:px-8 flex items-center justify-between py-6">
        <a href="#" className="flex items-center gap-2.5 group">
          <span className="brand-mark">
            <Camera size={18} strokeWidth={2.2} />
          </span>
          <span className="font-serif text-[22px] md:text-[24px] tracking-tight gold-gradient-text font-bold">
            AXSELL
          </span>
        </a>

        <nav className="flex items-center gap-2 md:gap-3">
          <button
            onClick={onSignIn}
            className="btn-gold px-4 py-2 text-sm font-medium rounded-md"
          >
            {brand.navSignIn}
          </button>
        </nav>
      </div>
    </header>
  );
}
